var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalbusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1210 1210",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M974.94 332.14H834.5v-59.95c1.27-54.27-31.8-101.62-76.6-124.17-44.56-23.67-99.39-32.1-162.6-32.29-65.3.08-117.94 14.27-156.72 42.9-38.96 28.3-60.36 72.95-59.83 117.41v56.1H238.4l-.8 395.58.8 388.01h736.55l1.66-341.8zm-507.24-56.1c.48-19.04 6.25-32.26 23.9-46.02 17.83-13.44 51.21-25.44 103.7-25.37 54.57-.2 97.06 8.72 120.43 21.65 23.16 14.15 28.56 22.74 29.85 45.9v59.94h-277.9c.02-16.8.02-36.7.02-56.1zm385.03 513.19c-16.84 23.86-48.47 53.44-94.9 88.74-74.04 56.13-123.5 94.65-148.41 115.49L469.6 889.56c-46.79-34.62-79.43-65.37-97.93-92.27-23.9-34.63-35.84-74.97-35.84-121.04 0-50.06 10.6-91.77 31.8-125.05 26.24-41.34 65.29-62.04 117.11-62.04 55.53 0 97.08 25.59 124.68 76.74 20.2-36 41.05-58.87 62.6-68.66 11.77-5.35 32.3-8.08 61.57-8.08 51.83 0 91.02 18.5 117.61 55.49 23.56 32.6 35.34 75.8 35.34 129.6 0 44.7-11.28 83.03-33.81 114.98z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalbusiness);
export default __webpack_public_path__ + "static/media/Local business.2818e07037dd12a47a81d1397d2da86e.svg";
export { ForwardRef as ReactComponent };